const ShowFieldFromListByKey = (key, data) => {
  if (data && key) {
    return data[key] ? data[key] : "";
  }
};

export default ShowFieldFromListByKey;
